var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-dialog', {
    attrs: {
      "persistent": "",
      "max-width": "600px"
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function (_ref) {
        var on = _ref.on,
          attrs = _ref.attrs;
        return [_c('v-btn', _vm._g(_vm._b({
          staticClass: "pl-2 pr-4",
          attrs: {
            "color": "primary",
            "outlined": ""
          }
        }, 'v-btn', attrs, false), on), [_c('v-icon', {
          staticClass: "pr-2"
        }, [_vm._v("$key")]), _vm._v(" " + _vm._s(_vm.$t('profile.change_password')) + " ")], 1)];
      }
    }]),
    model: {
      value: _vm.dialog,
      callback: function ($$v) {
        _vm.dialog = $$v;
      },
      expression: "dialog"
    }
  }, [_c('v-card', [_c('v-card-title', [_c('span', {
    staticClass: "text-h5 text-capitalize"
  }, [_vm._v(_vm._s(_vm.$t('profile.change_password')))])]), _c('v-card-text', [_c('v-form', {
    ref: "form",
    model: {
      value: _vm.validForm,
      callback: function ($$v) {
        _vm.validForm = $$v;
      },
      expression: "validForm"
    }
  }, [_c('v-container', [_c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-text-field', {
    staticClass: "mb-0 pb-0",
    attrs: {
      "label": _vm.$t('profile.current_password'),
      "rules": [_vm.rules.required, _vm.rules.min],
      "error-messages": _vm.hasOldPasswordError ? _vm.oldPasswordError : [],
      "type": "password",
      "required": ""
    },
    model: {
      value: _vm.oldPassword,
      callback: function ($$v) {
        _vm.oldPassword = $$v;
      },
      expression: "oldPassword"
    }
  })], 1), _c('v-col', {
    staticClass: "mb-0 pb-0",
    attrs: {
      "cols": "12",
      "sm": "6"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": _vm.$t('profile.new_password'),
      "rules": [_vm.rules.required, _vm.rules.min, _vm.rules.differentFromOld],
      "error-messages": _vm.hasNewPasswordError ? _vm.newPasswordError : [],
      "type": "password",
      "required": ""
    },
    model: {
      value: _vm.newPassword,
      callback: function ($$v) {
        _vm.newPassword = $$v;
      },
      expression: "newPassword"
    }
  })], 1), _c('v-col', {
    staticClass: "mb-0 pb-0",
    attrs: {
      "cols": "12",
      "sm": "6"
    }
  }, [_c('v-text-field', {
    staticClass: "mb-0 pb-0",
    attrs: {
      "label": _vm.$t('profile.confirm_password'),
      "rules": [_vm.rules.required, _vm.rules.min, _vm.rules.matchingPasswords, _vm.rules.differentFromOld],
      "error-messages": _vm.hasNewPasswordError ? _vm.newPasswordError : [],
      "type": "password",
      "required": ""
    },
    model: {
      value: _vm.confirmPassword,
      callback: function ($$v) {
        _vm.confirmPassword = $$v;
      },
      expression: "confirmPassword"
    }
  })], 1)], 1)], 1)], 1)], 1), _c('v-card-actions', [_c('v-spacer'), _c('v-btn', {
    attrs: {
      "color": "blue darken-1",
      "text": ""
    },
    on: {
      "click": _vm.close
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('close')) + " ")]), _c('v-btn', {
    staticClass: "white--text",
    attrs: {
      "color": "blue darken-1",
      "disabled": !_vm.validForm
    },
    on: {
      "click": _vm.changePassword
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('profile.change')) + " ")])], 1)], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }